export const CommentStateType = (type) => {
  if (type === "comment_ka") {
    return "KA comments";
  }
  if (type === "comment_logistic") {
    return "Logistic comments";
  }
  if (type === "comment_management") {
    return "Management comments";
  }
  if (type === "comment_service") {
    return "Service comments";
  }
  if (type === "comment_tch_pickup") {
    return "Technorama pickup komentarai";
  }
  return "";
};

export const comment_type_options = [
  {
    label: CommentStateType("comment_ka"),
    value: "comment_ka",
  },
  {
    label: CommentStateType("comment_management"),
    value: "comment_management",
  },
  {
    label: CommentStateType("comment_logistic"),
    value: "comment_logistic",
  },
  {
    label: CommentStateType("comment_service"),
    value: "comment_service",
  },
  {
    label: CommentStateType("comment_tch_pickup"),
    value: "comment_tch_pickup",
  },
];
